// renewalColumn.tsx
import { formatCurrency } from "../../libs/utils";
import { dateByformat } from "../../../utils/dateHelper";
import { currencyFormat, statusLabel } from "../../../utils/media";
import { Tag } from "antd";
import React from "react";
import { formatString } from "../../../utils/formatString";

function getDaysBetween(start, end) {
  const startDate: any = new Date(start);
  const endDate: any = new Date(end);
  const msInDay: any = 1000 * 60 * 60 * 24;
  return Math.ceil((endDate - startDate) / msInDay);
}
// Full column definition (merged with leaseCol hidden fields)
export const renewalCol = [
  { id: 1, headerName: "Renewal Status", field: "leaseStatus", checked: true, hide: false },
  { id: 2, headerName: "Property", field: "propertyDetails.propertyName", checked: true, hide: false },
  { id: 3, headerName: "Unit Code", field: "propertyDetails.unitCode", checked: true, hide: false },
  { id: 4, headerName: "Tenant", field: "tenantDetails.tenantNameEN", checked: true, hide: false },
  { id: 5, headerName: "Annual Rent", field: "bookingTerms.annualBaseRent", checked: true, hide: false },
  { id: 6, headerName: "Start Date", field: "leaseTerms.leaseStartDate", checked: true, hide: false },
  { id: 7, headerName: "End Date", field: "leaseTerms.leaseEndDate", checked: true, hide: false },
  { id: 8, headerName: "Contract Type", field: "leaseType", checked: true, hide: false },
  { id: 9, headerName: "AWB No", field: "shipmentNumber", checked: true, hide: false },
  { id: 10, headerName: "Owner Name", field: "ownerName", checked: true, hide: false },
  { id: 11, headerName: "Property Admin", field: "adminManager.name", checked: true, hide: false },

  // Extra fields from leaseCol (kept hidden)
  { id: 12, headerName: "Nationality", field: "tenantDetails.nationality", checked: false, hide: true },
  { id: 13, headerName: "Email", field: "tenantDetails.email", checked: false, hide: true },
  { id: 14, headerName: "Marital Status", field: "tenantDetails.maritalStatus", checked: false, hide: true },
  { id: 15, headerName: "Signatory Name", field: "signatoryName", checked: false, hide: true },
  { id: 16, headerName: "Signatory Designation", field: "signatoryDesignation", checked: false, hide: true },
  { id: 17, headerName: "Lease Nature", field: "leaseTerms.leaseNature", checked: false, hide: true },
  { id: 18, headerName: "Lease Executive", field: "leaseManager.name", checked: false, hide: true },
  { id: 19, headerName: "External Agent", field: "externalAgent", checked: false, hide: true },
  { id: 20, headerName: "Vacating Date", field: "vacatingDate", checked: false, hide: true },
  { id: 21, headerName: "Occupants", field: "tenantDetails.numberOfOcupants", checked: false, hide: true },
  { id: 22, headerName: "Rent Free Days", field: "leaseTerms.rentFreeDays", checked: false, hide: true },
  { id: 23, headerName: "Rent Free Start", field: "leaseTerms.rentFreeStartDate", checked: false, hide: true },
  { id: 24, headerName: "Rent Free End", field: "leaseTerms.rentFreeEndDate", checked: false, hide: true },
  { id: 25, headerName: "Move-in Date", field: "leaseTerms.moveInDate", checked: false, hide: true },
  { id: 26, headerName: "Ejari Contract No", field: "ejari.contractNumber", checked: false, hide: true },
  { id: 27, headerName: "Bedrooms", field: "propertyDetails.unitSubType", checked: false, hide: true },
  { id: 28, headerName: "Usage Type", field: "propertyDetails.usagesType", checked: false, hide: true },
  { id: 29, headerName: "Built-up Area", field: "propertyDetails.areaSqft", checked: false, hide: true },
  { id: 30, headerName: "Unit Type", field: "unitType", checked: false, hide: true },
  { id: 31, headerName: "Business Unit", field: "businessUnit", checked: false, hide: true },
  { id: 32, headerName: "Is AutoPay Active", field: "isAutoPayActive", checked: false, hide: true },

  // Already present in renewalCol
  { id: 33, headerName: "Unit Approved Rent", field: "unitApprovedRent", checked: true, hide: false },
  { id: 34, headerName: "Contract Rent", field: "bookingTerms.contractRent", checked: true, hide: false },
  { id: 35, headerName: "Payments", field: "bookingTerms.numberOfInstallments", checked: true, hide: false },

  { id: 36, headerName: "DEWA", field: "propertyDetails.dewa", checked: false, hide: true },
  { id: 37, headerName: "Address Line 1", field: "propertyDetails.address.addressLine1", checked: false, hide: true },
  { id: 38, headerName: "Address Line 2", field: "propertyDetails.address.addressLine2", checked: false, hide: true },
  { id: 39, headerName: "Community", field: "propertyDetails.address.community", checked: false, hide: true },
  { id: 40, headerName: "Sub Community", field: "propertyDetails.address.subCommunity", checked: false, hide: true },
  { id: 41, headerName: "Security Deposit", field: "leaseTerms.securityDeposit", checked: false, hide: true },
  { id: 42, headerName: "No. Of Installments", field: "bookingTerms.numberOfInstallments", checked: false, hide: true },
  { id: 43, headerName: "Mobile", field: "tenantDetails.mobileNumber", checked: false, hide: true },
  {
    id: 44,
    headerName: "Direct Debit Enabled",
    field: "propertyDetails?.isDirectDebitEnable",
    checked: false,
    hide: true,
  },
  { id: 45, headerName: "Approved Rate", field: "approvedRate", checked: false, hide: true },
  { id: 145, headerName: "ID", field: "recordNumber", checked: false, hide: true },
  { id: 46, headerName: "Actions", field: "action", checked: true, hide: false },
];

export const renewalColumn = (renewalColumns, MoreAction, props) => {
  return renewalColumns.map((col) => {
    if (col.field === "leaseStatus") {
      return {
        ...col,
        minWidth: 220,
        cellRendererFramework: ({ data }) => {
          const renewal_accepted = props?.booking?.leaseStatusHistory?.find(
            (status) => status?.status === "renewal_accepted" || status?.status === "renewal_confirmed"
          );
          const displayStatusKey =
            props?.booking?.leaseType === "renewal" && !renewal_accepted ? data?.renewalStatus : data?.leaseStatus;
          const tagColor = displayStatusKey === "lease_expired" ? "error" : "warning";

          return props?.booking?.leaseType === "renewal" && !renewal_accepted ? (
            <Tag className="tag-sm" color={tagColor}>
              {statusLabel(data?.renewalStatus, data?.leaseStatusHistory)}
            </Tag>
          ) : (
            <Tag className="tag-sm" color={tagColor}>
              {statusLabel(data?.leaseStatus, data?.leaseStatusHistory)}
            </Tag>
          );
        },
      };
    } else if (col.field === "bookingTerms.annualBaseRent") {
      return {
        ...col,
        minWidth: 220,
        align: "right",
        cellRendererFramework: ({ data }) =>
          data?.bookingTerms?.annualBaseRent ? (
            <div>{currencyFormat(data?.bookingTerms?.renewalAmount || data?.bookingTerms?.annualBaseRent)}</div>
          ) : (
            ""
          ),
      };
    } else if (col.field === "leaseTerms.leaseStartDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => dateByformat(data?.leaseTerms?.leaseStartDate, "DD-MM-YYYY"),
      };
    } else if (col.field === "leaseTerms.leaseEndDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => dateByformat(data?.leaseTerms?.leaseEndDate, "DD-MM-YYYY"),
      };
    } else if (col.field === "leaseType") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => statusLabel(data?.leaseType),
      };
    } else if (col.field === "bookingTerms.contractRent") {
      return {
        ...col,
        minWidth: 220,
        align: "right",
        cellRendererFramework: ({ data }) =>
          data?.bookingTerms?.annualBaseRent ? (
            <div>{currencyFormat(data?.bookingTerms?.contractRent) || "-"}</div>
          ) : (
            ""
          ),
      };
    } else if (col.field === "action") {
      return {
        ...col,
        maxWidth: 200,
        pinned: "right",
        cellRendererFramework: (row) => MoreAction(row),
      };
    } else if (col.field === "leaseTerms.rentFreeStartDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => dateByformat(data?.leaseTerms?.rentFreeStartDate, "DD-MM-YYYY"),
        minWidth: 150,
      };
    } else if (col.field === "leaseTerms.rentFreeEndDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => dateByformat(data?.leaseTerms?.rentFreeEndDate, "DD-MM-YYYY"),
        minWidth: 150,
      };
    } else if (col.field === "leaseTerms.moveInDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => dateByformat(data?.leaseTerms?.moveInDate, "DD-MM-YYYY"),
        minWidth: 150,
      };
    } else if (col.field === "vacatingDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => dateByformat(data?.vacatingDate, "DD-MM-YYYY"),
        minWidth: 150,
      };
    } else if (col.field === "leaseTerms.rentFreeDays") {
      return {
        ...col,
        cellRendererFramework: ({ data }) =>
          getDaysBetween(data?.leaseTerms?.rentFreeStartDate, data?.leaseTerms?.rentFreeEndDate),
      };
    } else if (col.field === "propertyDetails?.isDirectDebitEnable") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => <span>{data?.propertyDetails?.isDirectDebitEnable ? "Yes" : "No"}</span>,
      };
    } else if (col.field === "leaseTerms.securityDeposit") {
      return {
        ...col,
        type: "rightAligned",
        cellRendererFramework: ({ data }) => formatCurrency(data?.leaseTerms?.securityDeposit),
      };
    }
    return col;
  });
};
